module.exports = __webpack_public_path__ + "img/car-blue.27542981.svg";